var map = {
	"./alelo-icon.png": "0003",
	"./american-express-icon.png": "a71e",
	"./amex-icon.png": "361d",
	"./amex-icon.svg": "7d56",
	"./elo-icon.png": "8597",
	"./hipercard-icon.png": "3078",
	"./mastercard-icon.png": "7904",
	"./pix-icon.png": "765f",
	"./visa-icon.png": "74af"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";